'use client';
import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

export default function WhatsAppFloat() {
  const [open, setOpen] = useState(false);

  return (
    <div className="whatsapp-float">
      {open && (
        <div className="mb-3 w-72 bg-card rounded-2xl shadow-modal border border-border overflow-hidden animate-slide-up">
          <div className="bg-green-600 px-4 py-3 flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center">
              <MessageCircle size={18} className="text-white" />
            </div>
            <div>
              <div className="text-white font-semibold text-sm">51 Plus Lab Support</div>
              <div className="text-green-200 text-xs">Typically replies within minutes</div>
            </div>
            <button
              className="ml-auto text-white/70 hover:text-white transition-colors"
              onClick={() => setOpen(false)}
              aria-label="Close WhatsApp chat"
            >
              <X size={16} />
            </button>
          </div>
          <div className="p-4 space-y-2.5">
            <div className="bg-green-50 rounded-xl rounded-tl-none px-3 py-2 text-sm text-foreground max-w-[85%]">
              👋 Hi! How can we help you today?
            </div>
            <div className="grid grid-cols-1 gap-2 pt-1">
              {[
                'Book a Test',
                'Check Health Packages',
                'Home Collection',
                'Download Reports',
                'Corporate Inquiry',
              ]?.map((opt) => (
                <a
                  key={`wa-opt-${opt}`}
                  href={`https://wa.me/919818986535?text=${encodeURIComponent(opt)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-3 py-2 rounded-lg border border-border text-sm text-foreground hover:bg-muted hover:text-primary transition-colors text-left"
                >
                  {opt}
                </a>
              ))}
            </div>
          </div>
          <div className="px-4 pb-4">
            <a
              href="https://wa.me/919818986535"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-green w-full justify-center text-sm py-2.5"
            >
              <MessageCircle size={15} />
              Open WhatsApp
            </a>
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className="w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 text-white shadow-modal flex items-center justify-center transition-all duration-200 hover:scale-105 active:scale-95"
        aria-label="Chat on WhatsApp"
      >
        {open ? <X size={22} /> : <MessageCircle size={24} />}
      </button>
    </div>
  );
}